import chroma from "chroma-js"
import tailwindConfig from "../../tailwind.config"

const isSSR = typeof window === "undefined"

// This function checks if the button text has enough contrast in relation to the background
export function getButtonTextColor(kind: string, disabled: boolean) {
  if (isSSR || disabled) return "text-white"
  if (kind === "secondary") return "text-gray-900"

  const hue = getComputedStyle(document.documentElement).getPropertyValue(
    "--color-brand-hue"
  )

  // eslint-disable-next-line prefer-destructuring
  const accent = tailwindConfig.theme.colors.brand.accent
  const resolvedBgColor = accent.replace("var(--color-brand-hue)", hue)
  const passesContrastCheck = chroma.contrast(resolvedBgColor, "white") > 4.5

  return passesContrastCheck ? "text-white" : "text-gray-900"
}
